import React, { useState, useEffect } from 'react';
import './PitchBackground.css';

const PITCH_STYLES = ['vertical', 'horizontal', 'checkerboard', 'diagonal', 'circles'];

interface PitchBackgroundProps {
    children?: React.ReactNode;
    className?: string;
    randomizeOnMount?: boolean;
    currentWeek?: number;
    style?: React.CSSProperties;
}

export const PitchBackground: React.FC<PitchBackgroundProps> = ({ children, className, randomizeOnMount, currentWeek, style }) => {
    const [pitchStyle, setPitchStyle] = useState(PITCH_STYLES[1]); // default to horizontal

    useEffect(() => {
        if (randomizeOnMount) {
            const randomStyle = PITCH_STYLES[Math.floor(Math.random() * PITCH_STYLES.length)];
            setPitchStyle(randomStyle);
        } else if (currentWeek !== undefined) {
            const period = Math.floor((currentWeek - 1) / 4);
            const storageKey = `psm_pitchStyle_period_${period}`;
            
            let style = localStorage.getItem(storageKey);
            
            if (!style || !PITCH_STYLES.includes(style)) {
                style = PITCH_STYLES[Math.floor(Math.random() * PITCH_STYLES.length)];
                localStorage.setItem(storageKey, style);
    
                // Clean up old keys to prevent localStorage bloat
                Object.keys(localStorage)
                    .filter(key => key.startsWith('psm_pitchStyle_period_') && key !== storageKey)
                    .forEach(key => localStorage.removeItem(key));
            }
            setPitchStyle(style);
        }
    }, [randomizeOnMount, currentWeek]);

    return (
        <div className={`pitch-background pitch-style-${pitchStyle} ${className || ''}`} style={style}>
            {/* Halfway line */}
            <div className="halfway-line"></div>
            
            {/* Center circle and spot */}
            <div className="center-circle"></div>
            <div className="center-spot"></div>
            
            {/* Penalty boxes */}
            <div className="pitch-marking penalty-box top"></div>
            <div className="pitch-marking penalty-box bottom"></div>
            
            {/* Goal boxes */}
            <div className="pitch-marking goal-box top"></div>
            <div className="pitch-marking goal-box bottom"></div>
            
            {/* Penalty spots */}
            <div className="penalty-spot top"></div>
            <div className="penalty-spot bottom"></div>
            
            {/* Penalty arcs */}
            <div className="pitch-marking penalty-arc top"></div>
            <div className="pitch-marking penalty-arc bottom"></div>
            
            {children}
        </div>
    );
};
